<template>
  <el-table :data="list" border style="width: 100%" height="100%" v-loading="loading">
    <el-table-column
      type="index"
      width="50"
      align="center"
    ></el-table-column>
    <el-table-column prop="title" align="center" label="标题"></el-table-column>
    <el-table-column width="110" align="center" label="发送类型">
      <template slot-scope="scope">
        {{ scope.row.sendUserType == 1 ? '所有用户' : '指定用户' }}
      </template>
    </el-table-column>
    <el-table-column prop="recipientList" align="center" label="用户邮箱"></el-table-column>
    <el-table-column align="center" label="人员信息">
      <template slot-scope="scope">
        <div>创建人: {{ scope.row.creater }}</div>
        <div>更新人: {{ scope.row.modifier }}</div>
      </template>
    </el-table-column>
    <el-table-column label="时间信息" align="center">
      <template slot-scope="scope">
        <div>创建时间: {{ scope.row.createDate | dateFormat }}</div>
        <div>发送时间: {{ scope.row.sendTime | dateFormat }}</div>
        <div>更新时间: {{ scope.row.modifyDate | dateFormat }}</div>
      </template>
    </el-table-column>
    <el-table-column prop="title" align="center" width="110" label="状态">
      <template slot-scope="{row}">
        {{ row.letterState == 0 ? '待发送' : row.letterState == 1 ? '已发送' : row.letterState == 2 ? '草稿箱' : '已撤销' }}
      </template>
    </el-table-column>
    <el-table-column label="操作" align="center" width="120">
      <template slot-scope="{row}">
        <el-popconfirm
          v-if="row.letterState == 1"
          title="确定撤销么"
          icon-color="red"
          @confirm="revocation(row)"
        >
          <el-button
            slot="reference"
            type="text"
            size="small"
            style="color: red;margin-right:14px"
            >撤销</el-button
          >
        </el-popconfirm>
        <el-button
          type="text"
          size="small"
          @click="editRow(row)"
          >查看</el-button
        >
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import API from '@/api'
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    loading:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    revocation(row) {
      API.messageCancelSending({ stationLetterId: row.id }).then(res => {
        console.log(res)
        this.$message.success('操作成功')
        this.$emit('revocation')
      })
    },
    editRow(row) {
      this.$router.push({
        path: "/operation/newFunction/add",
        query: {
          id: row.id,
          isLook: true,
          type: 2
        },
      })
    },
  }
}
</script>

<style lang="scss" scoped>
</style>